export default __webpack_public_path__ + "bubble-logo.a2a88ee1.svg";